import React, { useState, useEffect, useMemo, useCallback } from "react";
import styled from "styled-components";
import { useFilters, useSortBy, usePagination } from "react-table";
import { Modal, Button } from "react-bootstrap";

import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

import {
  getAdelantoChoferes,
  deleteAdelantoChofer,
  putAdelantoChofer,
} from "../helpers/rutaAdelantoChofer";

import { getChoferes } from "../helpers/rutaChoferes";
import { getCamiones } from "../helpers/rutaCamiones";
import { getViajes } from "../helpers/rutaViajes";
import { getPagochoferes } from "../helpers/rutaPagochofer";

import ModalCobroPagoExtraChofer from "../components/ModalCobroPagoExtraChofer";
import { getMovimientoExtraChoferes } from "../helpers/rutaMovimientoExtraChofer";

import ModalAdelantoChofer from "../components/ModalAdelantoChofer";
import ModalPagochofer from "../components/ModalPagochofer";
import Table from "./TableContainer";
import "../css/tablecomandas.css";

/* =========================
   ESTILOS
========================= */
const Styles = styled.div`
  .table-container {
    overflow: auto;
    height: 600px;
  }

  table {
    border: 1px solid black;
    border-spacing: 0;
    font-size: 13px;
  }

  th,
  td {
    padding: 0.5rem;
    border-bottom: 1px solid black;
    border-right: 1px solid black;
  }

  th {
    background-color: #778899;
    position: sticky;
    top: 0;
    z-index: 2;
    text-align: center;
    font-size: 12px;
  }

  td {
    background-color: white;
  }

  .pagination {
    padding: 0.5rem;
    background-color: #778899;
    font-size: 15px;
    font-weight: bold;
  }
`;

const FiltrosBar = styled.div`
  display: grid;

  grid-template-columns:
    120px
    120px
    minmax(210px, 1.5fr)
    110px
    105px
    140px
    140px;

  gap: 10px;

  align-items: end;

  margin-bottom: 12px;

  padding: 14px;

  border: 1px solid #e2e8f0;
  border-radius: 12px;

  background: #ffffff;

  box-shadow:
    0 3px 14px
    rgba(15, 23, 42, 0.035);

  .field {
    display: flex;
    flex-direction: column;

    min-width: 0;
  }

  label {
    margin-bottom: 5px;

    color: #59687d;

    font-size: 10px;
    font-weight: 600;

    white-space: nowrap;
  }

  input,
  select {
    width: 100%;
    height: 34px;

    box-sizing: border-box;

    padding: 0 8px;

    border: 1px solid #d7e0ea;
    border-radius: 7px;

    background: #ffffff;

    color: #24324a;

    font-size: 10.5px;

    outline: none;
  }

  input:focus,
  select:focus {
    border-color: #80a9dc;

    box-shadow:
      0 0 0 2px
      rgba(40, 104, 198, 0.07);
  }

  .detalle {
    grid-column: 1 / span 2;
  }

  .btns {
    grid-column: 3 / -1;

    display: flex;

    align-items: end;

    gap: 6px;

    flex-wrap: nowrap;
  }

  .btns button {
    min-width: 115px;
    height: 34px;

    padding: 5px 9px;

    border-radius: 7px;

    font-size: 10px;

    white-space: nowrap;
  }

  @media (max-width: 1200px) {
    grid-template-columns:
      repeat(4, minmax(120px, 1fr));

    .detalle {
      grid-column: span 2;
    }

    .btns {
      grid-column: 1 / -1;

      flex-wrap: wrap;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns:
      1fr 1fr;

    .detalle {
      grid-column: 1 / -1;
    }

    .btns {
      grid-column: 1 / -1;
    }
  }

  @media (max-width: 520px) {
    grid-template-columns: 1fr;

    .detalle,
    .btns {
      grid-column: 1;
    }

    .btns {
      flex-direction: column;

      align-items: stretch;
    }

    .btns button {
      width: 100%;
    }
  }
`;

const ResumenBar = styled.div`
  display: grid;

  grid-template-columns:
    repeat(6, minmax(0, 1fr));

  gap: 9px;

  margin-bottom: 12px;

  .card-resumen {
    min-height: 72px;

    padding: 10px 11px;

    border: 1px solid #e1e8f0;
    border-radius: 10px;

    background: #ffffff;

    box-shadow:
      0 3px 12px
      rgba(15, 23, 42, 0.035);

    transition:
      transform 0.15s ease,
      box-shadow 0.15s ease;
  }

  .card-resumen:hover {
    transform: translateY(-1px);

    box-shadow:
      0 5px 14px
      rgba(15, 23, 42, 0.055);
  }

  .titulo {
    margin-bottom: 5px;

    color: #738197;

    font-size: 9.5px;
    font-weight: 600;
  }

  .valor {
    color: #1e2d44;

    font-size: 17px;
    font-weight: 700;

    white-space: nowrap;

    font-variant-numeric:
      tabular-nums;
  }

  .btn {
    border-radius: 7px !important;

    font-size: 9px !important;

    padding: 3px 7px !important;
  }

  @media (max-width: 1100px) {
    grid-template-columns:
      repeat(3, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns:
      1fr;
  }
`;

const InformeChoferHeader = styled.div`
  display: flex;

  align-items: center;

  min-height: 78px;

  margin-bottom: 12px;

  padding: 14px 18px;

  border: 1px solid #dce5f0;
  border-radius: 14px;

  background:
    linear-gradient(
      120deg,
      #ffffff 0%,
      #f8fafc 65%,
      #eef4fb 100%
    );

  box-shadow:
    0 3px 14px
    rgba(15, 23, 42, 0.035);

  .header-icon {
    width: 46px;
    height: 46px;

    flex: 0 0 46px;

    display: flex;

    align-items: center;
    justify-content: center;

    margin-right: 13px;

    border-radius: 11px;

    background: #eaf2ff;

    color: #2868c6;

    font-size: 19px;
  }

  .header-text span {
    display: block;

    margin-bottom: 2px;

    color: #5f7fa8;

    font-size: 9px;
    font-weight: 700;

    letter-spacing: 1.7px;
  }

  .header-text h3 {
    margin: 0 0 3px 0;

    color: #18243a;

    font-size: 20px;
    font-weight: 700;
  }

  .header-text p {
    margin: 0;

    color: #748196;

    font-size: 10px;
  }

  @media (max-width: 768px) {
    padding: 12px;

    .header-icon {
      width: 42px;
      height: 42px;

      flex-basis: 42px;
    }

    .header-text h3 {
      font-size: 17px;
    }
  }
`;

/* =========================
   UTILS
========================= */
function toStartOfDay(dateStr) {
  if (!dateStr) return null;
  const d = new Date(`${dateStr}T00:00:00`);
  return isNaN(d) ? null : d;
}

function toEndOfDay(dateStr) {
  if (!dateStr) return null;
  const d = new Date(`${dateStr}T23:59:59`);
  return isNaN(d) ? null : d;
}

function norm(v) {
  return (v ?? "")
    .toString()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();
}

const num = (v) => Number(v || 0) || 0;

const $ = (n) =>
  num(n).toLocaleString("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const kmFmt = (n) =>
  num(n).toLocaleString("es-AR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

function firstPresent(...values) {
  for (const v of values) {
    if (v !== undefined && v !== null && v !== "") return v;
  }
  return null;
};

function getId(v) {
  if (!v) return "";
  if (typeof v === "string") return v;
  if (v?.$oid) return v.$oid;
  if (typeof v?._id === "string") return v._id;
  if (v?._id?.$oid) return v._id.$oid;
  if (typeof v?.id === "string") return v.id;
  return "";
}

function getDateValue(v) {
  if (!v) return "";
  if (typeof v === "string") return v;
  if (v?.$date) return v.$date;
  return "";
}

function dateOnly(value) {
  const raw = getDateValue(value) || value;
  if (!raw) return "";

  const s = String(raw).trim();

  // Caso Mongo/ISO: 2026-04-01T00:00:00.000Z
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[1]}-${m[2]}-${m[3]}`;

  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return "";

  return [
    d.getFullYear(),
    String(d.getMonth() + 1).padStart(2, "0"),
    String(d.getDate()).padStart(2, "0"),
  ].join("-");
}

function parseDateOnlyLocal(value) {
  const iso = dateOnly(value);
  if (!iso) return null;

  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d, 0, 0, 0, 0);
}

function formatFecha(value) {
  const iso = dateOnly(value);
  if (!iso) return "";

  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
}

function normalizarExtras(resp) {
  if (!resp) return [];
  if (Array.isArray(resp)) return resp;
  if (Array.isArray(resp.movimientos)) return resp.movimientos;
  if (Array.isArray(resp.data?.movimientos)) return resp.data.movimientos;
  if (Array.isArray(resp.data)) return resp.data;
  return [];
}

function getChoferLabel(c) {
  if (!c) return "";
  if (typeof c === "string") return "";

  return (
    c.chofer ||
    c.nombreyapellido ||
    [c.nombre, c.apellido].filter(Boolean).join(" ").trim() ||
    c.nombre ||
    c.razonsocial ||
    c.descripcion ||
    ""
  );
}

function getCamionLabel(c) {
  if (!c) return "";
  if (typeof c === "string") return "";

  return c.camion || c.patente || c.descripcion || "";
}

function getChoferId(x) {
  return getId(x?.chofer) || getId(x?.choferId);
}

function getCamionId(x) {
  return getId(x?.camion) || getId(x?.camionId);
}

function getFechaViaje(v) {
  return (
    getDateValue(v?.tramos?.[0]?.fecha) ||
    getDateValue(v?.fecha) ||
    getDateValue(v?.fechaviaje) ||
    getDateValue(v?.fechaViaje) ||
    getDateValue(v?.fechainicio) ||
    getDateValue(v?.fechaInicio) ||
    getDateValue(v?.createdAt) ||
    ""
  );
}

function getNroViaje(v) {
  return num(v?.nroViaje ?? v?.nroviaje);
}


function sumByKeys(arr, keys = ["monto"]) {
  if (!Array.isArray(arr)) return 0;

  return arr.reduce((acc, item) => {
    const valor =
      keys.reduce((found, key) => found ?? item?.[key], undefined) ?? 0;
    return acc + num(valor);
  }, 0);
}

function getTotalKmDesdeCombustible(v) {
  const filas = Array.isArray(v?.combustible) ? v.combustible : [];

  const kms = filas
    .map((item) =>
      num(
        firstPresent(
          item?.kmTablero,
          item?.kmtablero,
          item?.km,
          item?.odometro,
          item?.odómetro
        )
      )
    )
    .filter((n) => n > 0);

  if (kms.length < 2) return 0;

  return Math.max(...kms) - Math.min(...kms);
}

function getTotalKm(v) {
  const directo = num(
    firstPresent(
      v?.totalKm,
      v?.totalkm,
      v?.kmtotal,
      v?.kmTotal,
      v?.resumen?.totalKm,
      v?.resumenFinal?.totalKm,
      v?.resumenfinal?.totalKm
    )
  );

  if (directo) return directo;

  return getTotalKmDesdeCombustible(v);
}

function getValorKm(v) {
  return num(
    firstPresent(
      v?.tarifaPorKm,
      v?.tarifaporkm,
      v?.valorKm,
      v?.valorkm,
      v?.valorPorKm,
      v?.valorporkm,
      v?.precioKm,
      v?.preciokm,
      v?.tarifa,
      v?.resumen?.valorKm,
      v?.resumenFinal?.valorKm,
      v?.resumenfinal?.valorKm
    )
  );
}

function getTotalViaticos(v) {
  const directo = firstPresent(
    v?.totalViaticos,
    v?.resumen?.viaticos,
    v?.resumenFinal?.viaticos,
    v?.resumenfinal?.viaticos
  );

  if (directo !== null && directo !== undefined && directo !== "") {
    return num(directo);
  }

  return sumByKeys(v?.viaticos, ["monto", "importe", "total"]);
}

function getTotalGastos(v) {
  const directo = firstPresent(
    v?.totalGastos,
    v?.resumen?.gastos,
    v?.resumenFinal?.gastos,
    v?.resumenfinal?.gastos
  );

  if (directo !== null && directo !== undefined && directo !== "") {
    return num(directo);
  }

  return sumByKeys(v?.gastos, ["monto", "importe", "total"]);
}

function getTotalAdelantos(v) {
  const directo = firstPresent(
    v?.totalAdelantos,
    v?.resumen?.adelantos,
    v?.resumenFinal?.adelantos,
    v?.resumenfinal?.adelantos
  );

  if (directo !== null && directo !== undefined && directo !== "") {
    return num(directo);
  }

  return sumByKeys(v?.adelantos, ["monto", "importe", "total"]);
}

function getValorViaje(v) {
  const km = getTotalKm(v);
  const valorKm = getValorKm(v);
  return km * valorKm;
}

function getTotalACobrarViaje(v) {
  const valorViaje = getValorViaje(v);
  const viaticos = getTotalViaticos(v);
  const gastos = getTotalGastos(v);
  const adelantos = getTotalAdelantos(v);

  return valorViaje + viaticos + gastos - adelantos;
}

function getAppViajeId(app) {
  if (!app) return "";
  return getId(app?.viaje);
}

function normalizarChoferes(resp) {
  if (!resp) return [];
  if (Array.isArray(resp)) return resp;
  if (Array.isArray(resp.choferes)) return resp.choferes;
  if (Array.isArray(resp.chofer)) return resp.chofer;
  if (Array.isArray(resp.data?.choferes)) return resp.data.choferes;
  if (Array.isArray(resp.data?.chofer)) return resp.data.chofer;
  if (Array.isArray(resp.data)) return resp.data;
  return [];
}

function normalizarCamiones(resp) {
  if (!resp) return [];
  if (Array.isArray(resp)) return resp;
  if (Array.isArray(resp.camiones)) return resp.camiones;
  if (Array.isArray(resp.camion)) return resp.camion;
  if (Array.isArray(resp.data?.camiones)) return resp.data.camiones;
  if (Array.isArray(resp.data?.camion)) return resp.data.camion;
  if (Array.isArray(resp.data)) return resp.data;
  return [];
}

function normalizarViajes(resp) {
  if (!resp) return [];
  if (Array.isArray(resp)) return resp;
  if (Array.isArray(resp.viajes)) return resp.viajes;
  if (Array.isArray(resp.viaje)) return resp.viaje;
  if (Array.isArray(resp.data?.viajes)) return resp.data.viajes;
  if (Array.isArray(resp.data?.viaje)) return resp.data.viaje;
  if (Array.isArray(resp.data)) return resp.data;
  return [];
}

function normalizarPagos(resp) {
  if (!resp) return [];
  if (Array.isArray(resp)) return resp;
  if (Array.isArray(resp.pagos)) return resp.pagos;
  if (Array.isArray(resp.pago)) return resp.pago;
  if (Array.isArray(resp.data?.pagos)) return resp.data.pagos;
  if (Array.isArray(resp.data?.pago)) return resp.data.pago;
  if (Array.isArray(resp.data)) return resp.data;
  return [];
}

function normalizarAdelantos(resp) {
  if (!resp) return [];
  if (Array.isArray(resp)) return resp;
  if (Array.isArray(resp.adelantos)) return resp.adelantos;
  if (Array.isArray(resp.adelanto)) return resp.adelanto;
  if (Array.isArray(resp.data?.adelantos)) return resp.data.adelantos;
  if (Array.isArray(resp.data?.adelanto)) return resp.data.adelanto;
  if (Array.isArray(resp.data)) return resp.data;
  return [];
}

function firstDayOfMonthISO() {
  const d = new Date();
  const local = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  local.setDate(1);
  return local.toISOString().slice(0, 10);
}

function todayISO() {
  const d = new Date();
  const local = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 10);
}

function getUsuarioToken() {
  try {
    let token = localStorage.getItem("token") || "";

    if (!token) return null;

    // Por si quedó guardado con comillas
    token = token.replace(/^"|"$/g, "");

    const partes = token.split(".");
    if (partes.length < 2) return null;

    let base64 = partes[1]
      .replace(/-/g, "+")
      .replace(/_/g, "/");

    // Completa padding de Base64
    while (base64.length % 4) {
      base64 += "=";
    }

    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(
          (c) =>
            "%" +
            ("00" + c.charCodeAt(0).toString(16)).slice(-2)
        )
        .join("")
    );

    const payload = JSON.parse(jsonPayload);

    return payload.usuario || payload.user || payload;
  } catch (error) {
    console.error("No se pudo leer el usuario del token:", error);
    return null;
  }
}

/* =========================
   MODAL DETALLE
========================= */
function ModalDetalleMovimiento({ show, handleClose, movimiento }) {
  if (!movimiento) return null;

  const isLiquidacion = movimiento.tipomov === "LIQUIDACION";
  const isPago = movimiento.tipomov === "PAGO";
  const isAdelanto = movimiento.tipomov === "ADELANTO";

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {isLiquidacion
            ? "Detalle del viaje"
            : isPago
            ? "Detalle del pago"
            : isAdelanto
            ? "Detalle del adelanto"
            : "Detalle"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-3">
          <strong>Fecha:</strong> {formatFecha(movimiento.fecha)}
        </div>

        {isLiquidacion && (
          <>
            <div className="mb-2">
              <strong>Viaje:</strong> {movimiento.nroviaje}
            </div>
            <div className="mb-2">
              <strong>Chofer:</strong> {movimiento.choferLabel}
            </div>
            <div className="mb-2">
              <strong>Camión:</strong> {movimiento.camionLabel}
            </div>

            <table className="table table-sm table-bordered">
              <tbody>
                <tr>
                  <th style={{ width: "45%" }}>Km</th>
                  <td style={{ textAlign: "right" }}>{kmFmt(movimiento.totalkm)}</td>
                </tr>
                <tr>
                  <th>Valor km</th>
                  <td style={{ textAlign: "right" }}>$ {$(movimiento.valorkm)}</td>
                </tr>
                <tr>
                  <th>Valor viaje</th>
                  <td style={{ textAlign: "right" }}>$ {$(movimiento.valorviaje)}</td>
                </tr>
                <tr>
                  <th>Adelantos</th>
                  <td style={{ textAlign: "right" }}>$ {$(movimiento.adelantos)}</td>
                </tr>
                <tr>
                  <th>Subtotal</th>
                  <td style={{ textAlign: "right", fontWeight: "bold" }}>
                    $ {$(num(movimiento.valorviaje) - num(movimiento.adelantos))}
                  </td>
                </tr>
                <tr>
                  <th>Viáticos</th>
                  <td style={{ textAlign: "right" }}>$ {$(movimiento.viaticos)}</td>
                </tr>
                <tr>
                  <th>Subtotal</th>
                  <td style={{ textAlign: "right", fontWeight: "bold" }}>
                    $ {$(num(movimiento.valorviaje) - num(movimiento.adelantos) + num(movimiento.viaticos))}
                  </td>
                </tr>
                <tr>
                  <th>Gastos</th>
                  <td style={{ textAlign: "right" }}>$ {$(movimiento.gastos)}</td>
                </tr>
                <tr>
                  <th>Total a cobrar</th>
                  <td style={{ textAlign: "right", fontWeight: "bold", color: "#198754" }}>
                    $ {$(movimiento.totalacobrar ?? movimiento.liquidacion)}
                  </td>
                </tr>
                <tr>
                  <th>Pagado a este viaje</th>
                  <td style={{ textAlign: "right", color: "#0d6efd", fontWeight: "bold" }}>
                    $ {$(movimiento.pagadoviaje)}
                  </td>
                </tr>
                <tr>
                  <th>Debe cobrar</th>
                  <td
                    style={{
                      textAlign: "right",
                      fontWeight: "bold",
                      color: num(movimiento.debecobrar) >= 0 ? "#198754" : "#dc3545",
                    }}
                  >
                    $ {$(movimiento.debecobrar)}
                  </td>
                </tr>
              </tbody>
            </table>

            <h6>Adelantos</h6>
            {Array.isArray(movimiento.adelantosDetalle) &&
            movimiento.adelantosDetalle.length > 0 ? (
              <table className="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Descripción</th>
                    <th>Monto</th>
                  </tr>
                </thead>
                <tbody>
                  {movimiento.adelantosDetalle.map((a, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{a.descripcion || a.detalle || a.concepto || "-"}</td>
                      <td style={{ textAlign: "right" }}>
                        $ {$(a.monto || a.importe || a.total)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div>No hay adelantos cargados en este viaje.</div>
            )}
          </>
        )}

        {isPago && (
          <>
            <div className="mb-2">
              <strong>Nro Pago:</strong> {movimiento.nropago}
            </div>
            <div className="mb-2">
              <strong>Chofer:</strong> {movimiento.choferLabel}
            </div>
            <div className="mb-2">
              <strong>Medio de pago:</strong> {movimiento.mediopago || "-"}
            </div>
            <div className="mb-2">
              <strong>Observaciones:</strong> {movimiento.observaciones || "-"}
            </div>
            <div className="mb-3">
              <strong>Monto total:</strong> $ {$(movimiento.pago)}
            </div>

            <h6>Aplicaciones</h6>
            {Array.isArray(movimiento.aplicaciones) &&
            movimiento.aplicaciones.length > 0 ? (
              <table className="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Viaje</th>
                    <th>Monto aplicado</th>
                  </tr>
                </thead>
                <tbody>
                  {movimiento.aplicaciones.map((a, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{a.nroviaje || a.viaje?.nroViaje || a.viaje?.nroviaje || "-"}</td>
                      <td style={{ textAlign: "right" }}>$ {$(a.montoaplicado)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div>Este pago no tiene aplicaciones detalladas.</div>
            )}
          </>
        )}

        {isAdelanto && (
          <>
            <div className="mb-2">
              <strong>Nro Adelanto:</strong> {movimiento.nropago}
            </div>
            <div className="mb-2">
              <strong>Chofer:</strong> {movimiento.choferLabel}
            </div>
            <div className="mb-2">
              <strong>Medio de pago:</strong> {movimiento.mediopago || "-"}
            </div>
            <div className="mb-2">
              <strong>Observaciones:</strong> {movimiento.observaciones || "-"}
            </div>
            <div className="mb-3">
              <strong>Monto adelanto:</strong> $ {$(movimiento.pago)}
            </div>
          </>
        )}

      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

/* =========================
   COMPONENTE PRINCIPAL
========================= */
export default function AppCtaCteChoferReactTable() {
  const usuarioActual = useMemo(() => getUsuarioToken(), []);

  const emailUsuario = String(
    usuarioActual?.email ||
    usuarioActual?.correo ||
    ""
  )
    .trim()
    .toLowerCase();

  const nombreUsuario = [
    usuarioActual?.nombres || usuarioActual?.nombre,
    usuarioActual?.apellidos || usuarioActual?.apellido,
  ]
    .filter(Boolean)
    .join(" ")
    .trim()
    .toLowerCase();

  const esPabloSaya =
    emailUsuario === "pablonsaya@hotmail.com" ||
    nombreUsuario === "pablo saya";
    console.log("USUARIO TOKEN:", usuarioActual);

    console.log("EMAIL:", emailUsuario);
    console.log("NOMBRE:", nombreUsuario);
    console.log("ES PABLO:", esPabloSaya);

  const [adelantoEditar, setAdelantoEditar] = useState(null);
  const [showEditarAdelanto, setShowEditarAdelanto] = useState(false);
  const [guardandoAdelanto, setGuardandoAdelanto] = useState(false);

  const [formEditarAdelanto, setFormEditarAdelanto] = useState({
    fecha: "",
    monto: "",
    observaciones: "",
  });

  const [choferes, setChoferes] = useState([]);
  const [camiones, setCamiones] = useState([]);
  const [viajes, setViajes] = useState([]);
  const [pagos, setPagos] = useState([]);
  const [extras, setExtras] = useState([]);
  const [adelantosChofer, setAdelantosChofer] = useState([]);

  const [loading, setLoading] = useState(true);
  const [showPagoModal, setShowPagoModal] = useState(false);
  const [showExtraModal, setShowExtraModal] = useState(false);
  const [detalleMov, setDetalleMov] = useState(null);
  const [showDetalle, setShowDetalle] = useState(false);
  const [showAdelantoModal, setShowAdelantoModal] = useState(false);
  

  const [filtros, setFiltros] = useState({
    desde: firstDayOfMonthISO(),
    hasta: todayISO(),
    chofer: "",
    tipo: "",
    nroviaje: "",
    camion: "",
    mediopago: "",
    detalle: "",
  });

  const setF = (k, v) => setFiltros((prev) => ({ ...prev, [k]: v }));

  /* =========================
     FETCH
  ========================= */
  const fetchData = useCallback(async () => {
    setLoading(true);

    try {
      const results = await Promise.allSettled([
        getChoferes(),
        getCamiones(),
        getViajes(),
        getPagochoferes(),
        getMovimientoExtraChoferes(),
        getAdelantoChoferes(),
      ]);

      const adelantosResp =
        results[5].status === "fulfilled" ? results[5].value : null;

      setAdelantosChofer(normalizarAdelantos(adelantosResp));

      const extrasResp =
        results[4].status === "fulfilled" ? results[4].value : null;
      
      setExtras(normalizarExtras(extrasResp));

      const choferesResp =
        results[0].status === "fulfilled" ? results[0].value : null;
      const camionesResp =
        results[1].status === "fulfilled" ? results[1].value : null;
      const viajesResp =
        results[2].status === "fulfilled" ? results[2].value : null;
      const pagosResp =
        results[3].status === "fulfilled" ? results[3].value : null;

      setChoferes(normalizarChoferes(choferesResp));
      setCamiones(normalizarCamiones(camionesResp));
      setViajes(normalizarViajes(viajesResp));
      setPagos(normalizarPagos(pagosResp));
    } catch (error) {
      console.error("Error al cargar cuenta corriente de choferes:", error);
      setChoferes([]);
      setCamiones([]);
      setViajes([]);
      setPagos([]);
      setExtras([]);
      setAdelantosChofer([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const choferMap = useMemo(() => {
    const map = {};
    (choferes || []).forEach((c) => {
      map[getId(c)] = c;
    });
    return map;
  }, [choferes]);

  const adelantosActivos = useMemo(() => {
    return (adelantosChofer || []).filter((a) =>
      a?.estado ? a.estado === "activo" : a?.activo !== false
    );
  }, [adelantosChofer]);

  const camionMap = useMemo(() => {
    const map = {};
    (camiones || []).forEach((c) => {
      map[getId(c)] = c;
    });
    return map;
  }, [camiones]);

  const handleClosePago = () => {
    setShowPagoModal(false);
    fetchData();
  };

  const handleCloseAdelanto = () => {
    setShowAdelantoModal(false);
    fetchData();
  };

  const handleCloseExtra = () => {
  setShowExtraModal(false);
  fetchData();
};

  const handleDetalle = (row) => {
    setDetalleMov(row);
    setShowDetalle(true);
  };

  const closeDetalle = () => {
    setDetalleMov(null);
    setShowDetalle(false);
  };

  /* =========================
     BASES ACTIVAS
  ========================= */
  const viajesActivos = useMemo(() => {
    return (viajes || []).filter((v) =>
      v?.estado ? v.estado === "activo" : v?.activo !== false
    );
  }, [viajes]);

  const pagosActivos = useMemo(() => {
    return (pagos || []).filter((p) => p?.estado === "activo");
  }, [pagos]);

  const extrasActivos = useMemo(() => {
  return (extras || []).filter((x) =>
      x?.estado ? x.estado === "activo" : x?.activo !== false
    );
  }, [extras]);
  /* =========================
     MAPA DE APLICADO POR VIAJE
  ========================= */
  const aplicadoPorViaje = useMemo(() => {
    const map = {};

    pagosActivos.forEach((p) => {
      (p.aplicaciones || []).forEach((app) => {
        const viajeId = getAppViajeId(app);
        if (!viajeId) return;
        map[viajeId] = num(map[viajeId]) + num(app.montoaplicado);
      });
    });

    return map;
  }, [pagosActivos]);

  /* =========================
     MOVIMIENTOS UNIFICADOS
  ========================= */
  const movimientosBase = useMemo(() => {
  const rowsViajes = viajesActivos.map((v) => {
    const fecha = getFechaViaje(v);
    const viajeId = getId(v);
    const choferId = getChoferId(v);
    const camionId = getCamionId(v);

    const choferObj = choferMap[choferId] || null;
    const camionObj = camionMap[camionId] || null;

    const valorkm = getValorKm(v);
    const totalkm = getTotalKm(v);
    const valorviaje = getValorViaje(v);
    const viaticos = getTotalViaticos(v);
    const gastos = getTotalGastos(v);
    const adelantos = getTotalAdelantos(v);

    const totalacobrar = getTotalACobrarViaje(v);
    const pagadoviaje = num(aplicadoPorViaje[viajeId]);
    const debecobrar = totalacobrar - pagadoviaje;

    return {
      _id: `viaje-${viajeId}`,
      idorigen: viajeId,
      tipomov: "LIQUIDACION",
      fecha,
      fechatxt: dateOnly(fecha),
      choferId,
      choferLabel: getChoferLabel(choferObj),
      camionId,
      camionLabel: getCamionLabel(camionObj),
      nroviaje: getNroViaje(v),
      nropago: "",
      mediopago: "",
      totalkm,
      valorkm,
      valorviaje,
      viaticos,
      gastos,
      adelantos,
      totalacobrar,
      liquidacion: totalacobrar,
      pagadoviaje,
      debecobrar,
      pago: 0,
      saldo: debecobrar,
      observaciones: v?.observaciones || "",
      detalle:
        `Viaje ${getNroViaje(v)} | KM ${kmFmt(totalkm)} | ` +
        `Valor viaje $ ${$(valorviaje)} | Adelantos $ ${$(adelantos)} | ` +
        `Viáticos $ ${$(viaticos)} | Gastos $ ${$(gastos)} | ` +
        `Total a cobrar $ ${$(totalacobrar)} | Pagado $ ${$(pagadoviaje)} | ` +
        `Debe cobrar $ ${$(debecobrar)}`,
      adelantosDetalle: Array.isArray(v?.adelantos) ? v.adelantos : [],
      aplicaciones: [],
      raw: v,
    };
  });

  const rowsPagos = pagosActivos.map((p) => {
    const fecha =
      getDateValue(p?.fechapago) ||
      getDateValue(p?.createdAt) ||
      p?.fechapago ||
      p?.createdAt ||
      "";

    const choferId = getId(p?.chofer);
    const choferObj = choferMap[choferId] || p?.chofer || null;

    const nroviajeTexto = Array.isArray(p?.aplicaciones)
      ? p.aplicaciones
          .map((a) => a?.nroviaje || a?.viaje?.nroViaje || a?.viaje?.nroviaje || "")
          .filter(Boolean)
          .join(", ")
      : "";

    return {
      _id: `pago-${getId(p) || p._id}`,
      idorigen: getId(p) || p._id,
      tipomov: "PAGO",
      fecha,
      fechatxt: dateOnly(fecha),
      choferId,
      choferLabel: getChoferLabel(choferObj),
      camionId: "",
      camionLabel: "",
      nroviaje: nroviajeTexto,
      nropago: p?.nropago || "",
      mediopago: p?.mediopago || "",
      totalkm: 0,
      valorkm: 0,
      valorviaje: 0,
      viaticos: 0,
      gastos: 0,
      adelantos: 0,
      liquidacion: 0,
      pago: num(p?.montototal),
      saldo: 0,
      observaciones: p?.observaciones || "",
      detalle:
        p?.observaciones ||
        `Pago ${p?.nropago || ""} aplicado a viaje/s: ${nroviajeTexto || "-"}`,
      adelantosDetalle: [],
      aplicaciones: Array.isArray(p?.aplicaciones) ? p.aplicaciones : [],
      raw: p,
    };
  });

  const rowsAdelantos = adelantosActivos.map((a) => {
    const fecha =
      getDateValue(a?.fecha) ||
      getDateValue(a?.createdAt) ||
      a?.fecha ||
      a?.createdAt ||
      "";

    const choferId = getId(a?.chofer);
    const choferObj = choferMap[choferId] || a?.chofer || null;

    return {
      _id: `adelanto-${getId(a) || a._id}`,
      idorigen: getId(a) || a._id,
      tipomov: "ADELANTO",
      fecha,
      fechatxt: dateOnly(fecha),
      choferId,
      choferLabel: getChoferLabel(choferObj),
      camionId: "",
      camionLabel: "",
      nroviaje: "",
      nropago: a?.nroadelanto || "",
      mediopago: a?.mediopago || "",
      totalkm: 0,
      valorkm: 0,
      valorviaje: 0,
      viaticos: 0,
      gastos: 0,
      adelantos: 0,
      totalacobrar: 0,
      liquidacion: 0,
      pagadoviaje: 0,
      debecobrar: 0,
      pago: num(a?.monto),
      saldo: -num(a?.monto),
      observaciones: a?.observaciones || "",
      detalle:
        a?.observaciones ||
        `Adelanto a chofer ${getChoferLabel(choferObj)} | Monto $ ${$(a?.monto)}`,
      adelantosDetalle: [],
      aplicaciones: [],
      raw: a,
    };
  });
  
  const rowsExtras = extrasActivos.map((x) => {
    const fecha =
      getDateValue(x?.fecha) ||
      getDateValue(x?.createdAt) ||
      x?.fecha ||
      x?.createdAt ||
      "";

    const choferId = getId(x?.chofer);
    const choferObj = choferMap[choferId] || x?.chofer || null;

    const monto = num(x?.monto);
    const suma = x?.impacto === "SUMA" ? monto : 0;
    const resta = x?.impacto === "RESTA" ? monto : 0;

    return {
      _id: `extra-${getId(x) || x._id}`,
      idorigen: getId(x) || x._id,
      tipomov: "EXTRA",
      fecha,
      fechatxt: dateOnly(fecha),
      choferId,
      choferLabel: getChoferLabel(choferObj),
      camionId: "",
      camionLabel: "",
      nroviaje: "",
      nropago: "",
      mediopago: x?.mediopago || "",
      totalkm: 0,
      valorkm: 0,
      valorviaje: 0,
      viaticos: 0,
      gastos: 0,
      adelantos: 0,
      liquidacion: suma,
      pago: resta,
      saldo: suma - resta,
      observaciones: x?.observaciones || "",
      detalle: `Movimiento extraordinario | ${x?.impacto} | ${x?.observaciones || ""}`,
      adelantosDetalle: [],
      aplicaciones: [],
      raw: x,
    };
  });

  return [...rowsViajes, ...rowsPagos, ...rowsAdelantos, ...rowsExtras].sort((a, b) => {
    const fa = parseDateOnlyLocal(a.fecha)?.getTime() ?? 0;
    const fb = parseDateOnlyLocal(b.fecha)?.getTime() ?? 0;

    if (fa !== fb) return fa - fb;

    const orden = { LIQUIDACION: 1, EXTRA: 2, ADELANTO: 3, PAGO: 4 };
    return (orden[a.tipomov] || 9) - (orden[b.tipomov] || 9);
  });
}, [
  viajesActivos,
  pagosActivos,
  adelantosActivos,
  extrasActivos,
  aplicadoPorViaje,
  choferMap,
  camionMap,
]);

  /* =========================
     FILTRO PRINCIPAL
  ========================= */
  const movimientosChofer = useMemo(() => {
    return movimientosBase.filter((r) => {
      if (filtros.chofer && r.choferId !== filtros.chofer) return false;
      return true;
    });
  }, [movimientosBase, filtros.chofer]);

  const dDesde = toStartOfDay(filtros.desde);
  const dHasta = toEndOfDay(filtros.hasta);

  const saldoInicial = useMemo(() => {
    return movimientosChofer.reduce((acc, r) => {
      const f = parseDateOnlyLocal(r.fecha);
      if (dDesde && f && f < dDesde) {
        return acc + num(r.liquidacion) - num(r.pago);
      }
      return acc;
    }, 0);
  }, [movimientosChofer, dDesde]);

  const movimientosPeriodoBase = useMemo(() => {
    return movimientosChofer.map((r) => ({ ...r }));
  }, [movimientosChofer]);

  const movimientosPeriodoConSaldo = useMemo(() => {
    let saldoAcum = saldoInicial;

    return movimientosPeriodoBase
      .filter((r) => {
        const f = parseDateOnlyLocal(r.fecha);
        if (dDesde && (!f || f < dDesde)) return false;
        if (dHasta && (!f || f > dHasta)) return false;
        return true;
      })
      .map((r) => {
        saldoAcum += num(r.liquidacion) - num(r.pago);
        return {
          ...r,
          saldoacumulado: saldoAcum,
        };
      });
  }, [movimientosPeriodoBase, dDesde, dHasta, saldoInicial]);

  /* =========================
     FILTROS SECUNDARIOS
  ========================= */
  const dataFiltrada = useMemo(() => {
    return movimientosPeriodoConSaldo.filter((r) => {
      if (filtros.tipo && !norm(r?.tipomov).includes(norm(filtros.tipo))) return false;
      if (filtros.nroviaje && !norm(r?.nroviaje).includes(norm(filtros.nroviaje))) return false;
      if (filtros.camion && !norm(r?.camionLabel).includes(norm(filtros.camion))) return false;
      if (filtros.mediopago && !norm(r?.mediopago).includes(norm(filtros.mediopago))) return false;

      const textoLibre = [
        r?.detalle,
        r?.observaciones,
        r?.choferLabel,
        r?.camionLabel,
      ]
        .filter(Boolean)
        .join(" ");

      if (filtros.detalle && !norm(textoLibre).includes(norm(filtros.detalle))) {
        return false;
      }

      return true;
    });
  }, [movimientosPeriodoConSaldo, filtros]);

  /* =========================
     RESUMEN
  ========================= */
  const resumen = useMemo(() => {
    const totalLiquidado = movimientosPeriodoConSaldo.reduce(
      (acc, r) => acc + num(r.liquidacion),
      0
    );

    const totalPagado = movimientosPeriodoConSaldo.reduce(
      (acc, r) => acc + num(r.pago),
      0
    );

    const totalDebeCobrarViajes = movimientosPeriodoConSaldo
      .filter((r) => r.tipomov === "LIQUIDACION")
      .reduce((acc, r) => acc + num(r.debecobrar), 0);

    const saldoFinal = saldoInicial + totalLiquidado - totalPagado;

    return {
      saldoInicial,
      totalLiquidado,
      totalPagado,
      totalDebeCobrarViajes,
      saldoFinal,
      cantidadMovs: movimientosPeriodoConSaldo.length,
    };
  }, [movimientosPeriodoConSaldo, saldoInicial]);

  /* =========================
     BOTONES RÁPIDOS
  ========================= */
  const limpiarFiltros = () => {
    setFiltros({
      desde: firstDayOfMonthISO(),
      hasta: todayISO(),
      chofer: "",
      tipo: "",
      nroviaje: "",
      camion: "",
      mediopago: "",
      detalle: "",
    });
  };

  const quickHoy = () => {
    const hoy = todayISO();
    setF("desde", hoy);
    setF("hasta", hoy);
  };

  const quickUltimos7 = () => {
    const hoy = new Date();
    const d7 = new Date(hoy);
    d7.setDate(hoy.getDate() - 6);

    const toISO = (dt) =>
      `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(
        dt.getDate()
      ).padStart(2, "0")}`;

    setF("desde", toISO(d7));
    setF("hasta", toISO(hoy));
  };

  const quickMesActual = () => {
    setF("desde", firstDayOfMonthISO());
    setF("hasta", todayISO());
  };

    /* =========================
     PDF
  ========================= */

  const exportarPDFChofer = () => {
    const doc = new jsPDF("l", "mm", "a4");

    const choferSel =
      choferes.find((c) => getId(c) === filtros.chofer) || null;

    const nombreChofer = filtros.chofer
      ? getChoferLabel(choferSel) || "Chofer seleccionado"
      : "Todos los choferes";

    const desdeTxt = filtros.desde || "-";
    const hastaTxt = filtros.hasta || "-";

    doc.setFontSize(16);
    doc.text("CTA CTE CHOFERES", 14, 14);

    doc.setFontSize(10);
    doc.text(`Chofer: ${nombreChofer}`, 14, 22);
    doc.text(`Desde: ${desdeTxt}`, 14, 28);
    doc.text(`Hasta: ${hastaTxt}`, 60, 28);

    doc.text(`Saldo inicial: $ ${$(resumen.saldoInicial)}`, 14, 36);
    doc.text(`Total a cobrar: $ ${$(resumen.totalLiquidado)}`, 75, 36);
    doc.text(`Total pagado: $ ${$(resumen.totalPagado)}`, 140, 36);
    doc.text(`Saldo final: $ ${$(resumen.saldoFinal)}`, 205, 36);

    const body = dataFiltrada.map((r) => [
      formatFecha(r.fecha),
      r.tipomov || "",
      r.choferLabel || "",
      r.camionLabel || "",
      r.nroviaje || "",
      r.tipomov === "LIQUIDACION" ? kmFmt(r.totalkm) : "",
      r.tipomov === "LIQUIDACION" ? `$ ${$(r.valorviaje)}` : "",
      r.tipomov === "LIQUIDACION" ? `$ ${$(r.adelantos)}` : "",
      r.tipomov === "LIQUIDACION" ? `$ ${$(r.viaticos)}` : "",
      r.tipomov === "LIQUIDACION" ? `$ ${$(r.gastos)}` : "",
      r.liquidacion ? `$ ${$(r.liquidacion)}` : "",
      r.pago ? `$ ${$(r.pago)}` : "",
      `$ ${$(r.saldoacumulado)}`,
    ]);

    const head = [[
      "Fecha",
      "Tipo",
      "Chofer",
      "Camión",
      "Viaje",
      "KM",
      "Valor Viaje",
      "Adelantos",
      "Viáticos",
      "Gastos",
      "Total a Cobrar",
      "Pago",
      "Saldo Acum."
    ]];

    autoTable(doc, {
      startY: 42,
      margin: { top: 6, right: 4, bottom: 6, left: 14 },
      theme: "grid",
      styles: {
        fontSize: 6.3,
        cellPadding: 0.9,
        overflow: "linebreak",
        valign: "middle",
        lineWidth: 0.1,
      },
      headStyles: {
        fontSize: 6.4,
        cellPadding: 1,
        halign: "center",
        valign: "middle",
      },
      bodyStyles: {
        fontSize: 6.1,
      },
      columnStyles: {
        0: { cellWidth: 16 },
        1: { cellWidth: 18},
        2: { cellWidth: 30 },
        3: { cellWidth: 30 },
        4: { cellWidth: 12, halign: "center" },
        5: { cellWidth: 12, halign: "right" },
        6: { cellWidth: 18, halign: "right" },
        7: { cellWidth: 18, halign: "right" },
        8: { cellWidth: 18, halign: "right" },
        9: { cellWidth: 18, halign: "right" },
        10: { cellWidth: 18, halign: "right" },
        11: { cellWidth: 18, halign: "right" },
        12: { cellWidth: 18, halign: "right" },
      },
      head,
      body,
    });
    const nombreArchivo = `cta_cte_chofer_${nombreChofer
      .replace(/\s+/g, "_")
      .toLowerCase()}_${desdeTxt}_${hastaTxt}.pdf`;

    doc.save(nombreArchivo);
  };
  /* =========================
     COLUMNAS
  ========================= */

const abrirEditarAdelanto = (row) => {
  if (!esPabloSaya) return;
  if (row?.tipomov !== "ADELANTO") return;

  const adelanto = row.raw;

  setAdelantoEditar(adelanto);

  setFormEditarAdelanto({
    fecha: dateOnly(adelanto?.fecha),
    monto: adelanto?.monto ?? "",
    observaciones: adelanto?.observaciones || "",
  });

  setShowEditarAdelanto(true);
};

const guardarEdicionAdelanto = async () => {
  if (!esPabloSaya || !adelantoEditar) return;

  const id = getId(adelantoEditar);

  if (!id) {
    alert("No se pudo identificar el adelanto.");
    return;
  }

  if (num(formEditarAdelanto.monto) <= 0) {
    alert("El monto debe ser mayor a 0.");
    return;
  }

  const confirmar = window.confirm(
    `¿Modificar el adelanto N° ${adelantoEditar.nroadelanto || ""}?`
  );

  if (!confirmar) return;

  setGuardandoAdelanto(true);

  try {
    const resp = await putAdelantoChofer(id, {
      fecha: formEditarAdelanto.fecha,
      monto: num(formEditarAdelanto.monto),
      observaciones: formEditarAdelanto.observaciones,

      // Conservamos estos datos.
      mediopago: adelantoEditar.mediopago,
      caja: getId(adelantoEditar.caja) || null,
      cuentaBancaria: getId(adelantoEditar.cuentaBancaria) || null,
    });

    if (!resp?.ok) {
      const mensaje =
        resp?.error?.error ||
        resp?.error?.message ||
        resp?.error ||
        "No se pudo modificar el adelanto.";

      alert(mensaje);
      return;
    }

    setShowEditarAdelanto(false);
    setAdelantoEditar(null);

    await fetchData();
  } catch (error) {
    console.error(error);
    alert("Error al modificar el adelanto.");
  } finally {
    setGuardandoAdelanto(false);
  }
};

const anularAdelanto = async (row) => {
  if (!esPabloSaya) return;
  if (row?.tipomov !== "ADELANTO") return;

  const adelanto = row.raw;
  const id = getId(adelanto);

  if (!id) {
    alert("No se pudo identificar el adelanto.");
    return;
  }

  const confirmar = window.confirm(
    `¿Seguro que desea ANULAR el adelanto N° ${
      adelanto?.nroadelanto || ""
    } por $ ${$(adelanto?.monto)}?\n\n` +
      "El importe será devuelto a la caja o cuenta bancaria correspondiente."
  );

  if (!confirmar) return;

  try {
    const resp = await deleteAdelantoChofer(id);

    if (!resp?.ok) {
      const mensaje =
        resp?.error?.error ||
        resp?.error?.message ||
        resp?.error ||
        "No se pudo anular el adelanto.";

      alert(mensaje);
      return;
    }

    await fetchData();
  } catch (error) {
    console.error(error);
    alert("Error al anular el adelanto.");
  }
};

const columns = useMemo(() => {
  const footerTotalNegro = (campo) => (info) => {
    const rows = info?.rows || [];

    const total = rows.reduce((sum, row) => {
      if (row.original.tipomov !== "LIQUIDACION") return sum;
      return sum + num(row.original[campo]);
    }, 0);

    return (
      <div
        style={{
          textAlign: "right",
          fontWeight: "bold",
          color: "black",
        }}
      >
        $ {$(total)}
      </div>
    );
  };

  return [
      {
        id: "ver",
        Header: "Ver",
        accessor: "_id",
        width: 50,
        Cell: ({ row }) => (
          <button
            className="action-btn action-btn--edit"
            title="Ver detalle"
            onClick={() => handleDetalle(row.original)}
          >
            <i className="fa fa-search" aria-hidden="true" />
          </button>
        ),
      },

      {
        id: "accionesAdelanto",
        Header: "Acciones",
        width: 90,

        Cell: ({ row }) => {
          if (!esPabloSaya) return null;

          if (row.original.tipomov !== "ADELANTO") {
            return null;
          }

          return (
            <div
              style={{
                display: "flex",
                gap: "5px",
                justifyContent: "center",
              }}
            >
              <button
                type="button"
                className="btn btn-warning btn-sm"
                title="Modificar adelanto"
                style={{
                  minWidth: 32,
                  padding: "3px 6px",
                }}
                onClick={() => abrirEditarAdelanto(row.original)}
              >
                <i className="fa fa-pencil" aria-hidden="true" />
              </button>

              <button
                type="button"
                className="btn btn-danger btn-sm"
                title="Anular adelanto"
                style={{
                  minWidth: 32,
                  padding: "3px 6px",
                }}
                onClick={() => anularAdelanto(row.original)}
              >
                <i className="fa fa-trash" aria-hidden="true" />
              </button>
            </div>
          );
        },
},
      {
        Header: "Tipo",
        accessor: "tipomov",
        width: 95,
      },
      {
        Header: "Fecha",
        accessor: (row) => dateOnly(row.fecha),
        id: "fecha",
        width: 95,
        Cell: ({ value }) => formatFecha(value),
      },
      {
        Header: "Chofer",
        accessor: "choferLabel",
        width: 240,
        Cell: ({ value }) => (
          <div
            style={{ whiteSpace: "nowrap", textAlign: "left" }}
            title={value}
          >
            {value}
          </div>
        ),
      },
      {
        Header: "Camión",
        accessor: "camionLabel",
        width: 130,
        Cell: ({ value }) => (
          <div style={{ whiteSpace: "nowrap" }} title={value}>
            {value}
          </div>
        ),
      },
      {
        Header: "Nro Viaje",
        accessor: "nroviaje",
        width: 80,
      },
      {
        Header: "Km",
        accessor: "totalkm",
        width: 90,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right" }}>{value ? kmFmt(value) : ""}</div>
        ),
      },
      {
        Header: "Valor Km",
        accessor: "valorkm",
        width: 100,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right" }}>
            {value ? `$ ${$(value)}` : ""}
          </div>
        ),
      },
      
      {
        Header: "Valor Viaje",
        accessor: "valorviaje",
        width: 120,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right" }}>
            {value ? `$ ${$(value)}` : ""}
          </div>
        ),
        Footer: footerTotalNegro("valorviaje"),
      },
      {
        Header: "Viáticos",
        accessor: "viaticos",
        width: 120,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right" }}>
            {value ? `$ ${$(value)}` : ""}
          </div>
        ),
        Footer: footerTotalNegro("viaticos"),
      },
      {
        Header: "Gastos",
        accessor: "gastos",
        width: 120,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right" }}>
            {value ? `$ ${$(value)}` : ""}
          </div>
        ),
        Footer: footerTotalNegro("gastos"),
      },
      {
        Header: "Adelantos",
        accessor: "adelantos",
        width: 120,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right" }}>
            {value ? `$ ${$(value)}` : ""}
          </div>
        ),
        Footer: footerTotalNegro("adelantos"),
      },
      
      {
        Header: "Total a cobrar",
        accessor: "liquidacion",
        width: 140,
        Cell: ({ value }) => (
          <div
            style={{
              textAlign: "right",
              color: num(value) >= 0 ? "green" : "red",
              fontWeight: "bold",
            }}
          >
            {value || value === 0 ? `$ ${$(value)}` : ""}
          </div>
        ),
        Footer: (info) => {
          const total = info.rows.reduce(
            (sum, row) => sum + num(row.values.liquidacion),
            0
          );
          return (
            <div style={{ textAlign: "right", fontWeight: "bold", color: "green" }}>
              $ {$(total)}
            </div>
          );
        },
      },
      {
        Header: "Pagado viaje",
        accessor: "pagadoviaje",
        width: 130,
        Cell: ({ row, value }) => (
          <div
            style={{
              textAlign: "right",
              color: row.original.tipomov === "LIQUIDACION" ? "#0d6efd" : "#999",
              fontWeight: "bold",
            }}
          >
            {row.original.tipomov === "LIQUIDACION" ? `$ ${$(value)}` : ""}
          </div>
        ),
        Footer: (info) => {
          const total = info.rows.reduce((sum, row) => {
            if (row.original.tipomov !== "LIQUIDACION") return sum;
            return sum + num(row.values.pagadoviaje);
          }, 0);

          return (
            <div
              style={{
                textAlign: "right",
                fontWeight: "bold",
                color: "#0d6efd",
              }}
            >
              $ {$(total)}
            </div>
          );
        },
      },
      {
        Header: "Debe cobrar",
        accessor: "debecobrar",
        width: 130,
        Cell: ({ row, value }) => (
          <div
            style={{
              textAlign: "right",
              color: num(value) >= 0 ? "#198754" : "#dc3545",
              fontWeight: "bold",
            }}
          >
            {row.original.tipomov === "LIQUIDACION" ? `$ ${$(value)}` : ""}
          </div>
        ),
        Footer: () => (
          <div
            style={{
              textAlign: "right",
              fontWeight: "bold",
              color: resumen.saldoFinal >= 0 ? "#198754" : "#dc3545",
            }}
          >
            $ {$(resumen.saldoFinal)}
          </div>
        ),
      },
      {
        Header: "Pago",
        accessor: "pago",
        width: 120,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right", color: "blue", fontWeight: "bold" }}>
            {value ? `$ ${$(value)}` : ""}
          </div>
        ),
        Footer: (info) => {
          const total = info.rows.reduce(
            (sum, row) => sum + num(row.values.pago),
            0
          );
          return (
            <div style={{ textAlign: "right", fontWeight: "bold", color: "blue" }}>
              $ {$(total)}
            </div>
          );
        },
      },
      // {
      //   Header: "Saldo Acum.",
      //   accessor: "saldoacumulado",
      //   width: 130,
      //   Cell: ({ value }) => (
      //     <div
      //       style={{
      //         textAlign: "right",
      //         fontWeight: "bold",
      //         color: num(value) >= 0 ? "#198754" : "#dc3545",
      //       }}
      //     >
      //       $ {$(value)}
      //     </div>
      //   ),
      // },
      {
        Header: "Medio Pago",
        accessor: "mediopago",
        width: 120,
      },
      {
        Header: "Nro Pago",
        accessor: "nropago",
        width: 80,
      },
      // {
      //   Header: "Km",
      //   accessor: "totalkm",
      //   width: 90,
      //   Cell: ({ value }) => (
      //     <div style={{ textAlign: "right" }}>{value ? kmFmt(value) : ""}</div>
      //   ),
      // },
      // {
      //   Header: "Valor Km",
      //   accessor: "valorkm",
      //   width: 100,
      //   Cell: ({ value }) => (
      //     <div style={{ textAlign: "right" }}>
      //       {value ? `$ ${$(value)}` : ""}
      //     </div>
      //   ),
      // },
      // {
      //   Header: "Valor Viaje",
      //   accessor: "valorviaje",
      //   width: 120,
      //   Cell: ({ value }) => (
      //     <div style={{ textAlign: "right" }}>
      //       {value ? `$ ${$(value)}` : ""}
      //     </div>
      //   ),
      // },
      {
        Header: "Detalle",
        accessor: "detalle",
        width: 700,
      },
    ];
  }, [resumen, esPabloSaya]);


  return (
<div className="container mt-4">

  <InformeChoferHeader>
    <div className="header-icon">
      <i
        className="fa fa-id-card-o"
        aria-hidden="true"
      />
    </div>

    <div className="header-text">
      <span>
        INFORMES
      </span>

      <h3>
        Cuenta Corriente de Choferes
      </h3>

      <p>
        Liquidaciones, pagos, adelantos,
        movimientos y saldos por chofer.
      </p>
    </div>
  </InformeChoferHeader>

  <FiltrosBar>
    <div className="field">
      <label style={{ fontSize: 14, padding: "8px 12px" }}>Fecha desde</label>
      <input
        type="date"
        value={filtros.desde}
        onChange={(e) => setF("desde", e.target.value)}
      />
    </div>

    <div className="field">
      <label style={{ fontSize: 14, padding: "8px 12px" }}>Fecha hasta</label>
      <input
        type="date"
        value={filtros.hasta}
        onChange={(e) => setF("hasta", e.target.value)}
      />
    </div>

    <div className="field">
      <label style={{ fontSize: 14, padding: "8px 12px" }}>Chofer</label>
      <select
        value={filtros.chofer}
        onChange={(e) => setF("chofer", e.target.value)}
      >
        <option value="">Todos</option>
        {choferes
          .filter((c) => c?.activo !== false)
          .sort((a, b) =>
            getChoferLabel(a).localeCompare(getChoferLabel(b), "es", {
              sensitivity: "base",
            })
          )
          .map((c) => (
            <option key={getId(c)} value={getId(c)}>
              {getChoferLabel(c)}
            </option>
          ))}
      </select>
    </div>

    <div className="field">
      <label style={{ fontSize: 14, padding: "8px 12px" }}>Tipo</label>
      <select
        value={filtros.tipo}
        onChange={(e) => setF("tipo", e.target.value)}
      >
        <option value="">Todos</option>
        <option value="LIQUIDACION">LIQUIDACION</option>
        <option value="EXTRA">EXTRA</option>
        <option value="PAGO">PAGO</option>
        <option value="ADELANTO">ADELANTO</option>
      </select>
    </div>

    <div className="field">
      <label style={{ fontSize: 14, padding: "8px 12px" }}>Nro Viaje</label>
      <input
        value={filtros.nroviaje}
        onChange={(e) => setF("nroviaje", e.target.value)}
      />
    </div>

    <div className="field">
      <label style={{ fontSize: 14, padding: "8px 12px" }}>Camión</label>
      <input
        value={filtros.camion}
        onChange={(e) => setF("camion", e.target.value)}
      />
    </div>

    <div className="field">
      <label style={{ fontSize: 14, padding: "8px 12px" }}>Medio pago</label>
      <input
        value={filtros.mediopago}
        onChange={(e) => setF("mediopago", e.target.value)}
      />
    </div>

    <div className="field detalle">
      <label style={{ fontSize: 14, padding: "8px 12px" }}>Detalle</label>
      <input
        value={filtros.detalle}
        onChange={(e) => setF("detalle", e.target.value)}
      />
    </div>

    <div className="btns">
      <button
        type="button"
        className="btn btn-outline-secondary btn-sm"
        onClick={quickHoy}
      >
        Hoy
      </button>

      <button
        type="button"
        className="btn btn-outline-success btn-sm"
        onClick={quickUltimos7}
      >
        Últimos 7 días
      </button>

      <button
        type="button"
        className="btn btn-outline-primary btn-sm"
        onClick={quickMesActual}
      >
        Mes actual
      </button>

      <button
        type="button"
        className="btn btn-outline-dark btn-sm"
        onClick={limpiarFiltros}
      >
        Limpiar
      </button>

      <button
        type="button"
        className="btn btn-success btn-sm"
        onClick={() => setShowPagoModal(true)}
      >
        Registrar Pago
      </button>

      <button
        type="button"
        className="btn btn-primary btn-sm"
        onClick={() => setShowAdelantoModal(true)}
      >
        Registrar Adelanto
      </button>

      <button
        type="button"
        className="btn btn-danger btn-sm"
        onClick={exportarPDFChofer}
      >
        Exportar PDF
      </button>

    </div>
  </FiltrosBar>

      <ResumenBar>
        <div className="card-resumen">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: "0.5rem",
            }}
          >
            <div>
              <div className="titulo">Saldo inicial</div>
              <div
                className="valor"
                style={{ color: resumen.saldoInicial >= 0 ? "#198754" : "#dc3545" }}
              >
                $ {$(resumen.saldoInicial)}
              </div>
            </div>

            <Button
              variant="outline-dark"
              size="sm"
              onClick={() => setShowExtraModal(true)}
              style={{ whiteSpace: "nowrap" }}
            >
              Cobro/Pago
            </Button>
          </div>
        </div>

        <div className="card-resumen">
          <div className="titulo">Total liquidado</div>
          <div className="valor" style={{ color: "#198754" }}>
            $ {$(resumen.totalLiquidado)}
          </div>
        </div>

        <div className="card-resumen">
          <div className="titulo">Total pagado</div>
          <div className="valor" style={{ color: "#0d6efd" }}>
            $ {$(resumen.totalPagado)}
          </div>
        </div>

        <div className="card-resumen">
          <div className="titulo">Saldo final</div>
          <div
            className="valor"
            style={{ color: resumen.saldoFinal >= 0 ? "#198754" : "#dc3545" }}
          >
            $ {$(resumen.saldoFinal)}
          </div>
        </div>

        <div className="card-resumen">
          <div className="titulo">Movimientos del período</div>
          <div className="valor">{resumen.cantidadMovs}</div>
        </div>

        <div className="card-resumen">
          <div className="titulo">Debe cobrar actual</div>
          <div
            className="valor"
            style={{
              color: resumen.totalDebeCobrarViajes >= 0 ? "#198754" : "#dc3545",
            }}
          >
            $ {$(resumen.saldoFinal)}
          </div>
        </div>
      </ResumenBar>

      <Styles>
        <div className="table-container">
          <Table
            columns={columns}
            data={dataFiltrada}
            loading={loading}
            plugins={[useFilters, useSortBy, usePagination]}
          />
        </div>
      </Styles>

      <Modal
        show={showEditarAdelanto}
        onHide={() => {
          if (!guardandoAdelanto) {
            setShowEditarAdelanto(false);
            setAdelantoEditar(null);
          }
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Modificar adelanto
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="form-group">
            <label>Chofer</label>

            <input
              className="form-control"
              value={
                adelantoEditar
                  ? getChoferLabel(adelantoEditar.chofer)
                  : ""
              }
              disabled
            />
          </div>

          <div className="form-group">
            <label>Fecha</label>

            <input
              type="date"
              className="form-control"
              value={formEditarAdelanto.fecha}
              onChange={(e) =>
                setFormEditarAdelanto((prev) => ({
                  ...prev,
                  fecha: e.target.value,
                }))
              }
            />
          </div>

          <div className="form-group">
            <label>Monto</label>

            <input
              type="number"
              min="0"
              step="0.01"
              className="form-control"
              value={formEditarAdelanto.monto}
              onChange={(e) =>
                setFormEditarAdelanto((prev) => ({
                  ...prev,
                  monto: e.target.value,
                }))
              }
            />
          </div>

          <div className="form-group">
            <label>Medio de pago</label>

            <input
              className="form-control"
              value={adelantoEditar?.mediopago || ""}
              disabled
            />
          </div>

          <div className="form-group">
            <label>Observaciones</label>

            <textarea
              className="form-control"
              rows="3"
              value={formEditarAdelanto.observaciones}
              onChange={(e) =>
                setFormEditarAdelanto((prev) => ({
                  ...prev,
                  observaciones: e.target.value,
                }))
              }
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            disabled={guardandoAdelanto}
            onClick={() => {
              setShowEditarAdelanto(false);
              setAdelantoEditar(null);
            }}
          >
            Cancelar
          </Button>

          <Button
            variant="success"
            disabled={guardandoAdelanto}
            onClick={guardarEdicionAdelanto}
          >
            {guardandoAdelanto
              ? "Guardando..."
              : "Guardar cambios"}
          </Button>
        </Modal.Footer>
      </Modal>

      <ModalPagochofer
        key={`${filtros.chofer}-${filtros.desde}-${filtros.hasta}-${resumen.saldoFinal}`}
        show={showPagoModal}
        setShow={setShowPagoModal}
        onGuardado={handleClosePago}
        choferInicial={filtros.chofer || ""}
        desdeInicial={filtros.desde}
        hastaInicial={filtros.hasta}
        saldoCtaCteInicial={resumen.saldoFinal}
      />

      {showAdelantoModal && (
        <ModalAdelantoChofer
          show={showAdelantoModal}
          setShow={setShowAdelantoModal}
          onGuardado={handleCloseAdelanto}
        />
      )}

      {showExtraModal && (
        <ModalCobroPagoExtraChofer
          show={showExtraModal}
          setShow={setShowExtraModal}
          onGuardado={handleCloseExtra}
          choferInicial={filtros.chofer || ""}
        />
      )}

      {detalleMov && (
        <ModalDetalleMovimiento
          show={showDetalle}
          handleClose={closeDetalle}
          movimiento={detalleMov}
        />
      )}
    </div>
  );
}